export default __webpack_public_path__ + "static/media/Icon-annotation.677fa23e.svg";